import styled from 'styled-components';

export const ControlsItem = styled.div`
  position: relative;
  font-size: 14px;
  line-height: 1;

  & > button {
    position: relative;

    &:hover {
      opacity: 0.7;
    }
  }
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;

  ${ControlsItem} + ${ControlsItem} {
    margin-left: 14px;
  }
`;
